// twoColumnChartSlice.js
import { createSlice } from "@reduxjs/toolkit";

const twoColumnChartSlice = createSlice({
  name: "twoColumnChart",
  initialState: {
    currentSalesType: null, // default sales type
  },
  reducers: {
    updateSalesType: (state, action) => {
      state.currentSalesType = action.payload;
    },
  },
});



export const { updateSalesType } = twoColumnChartSlice.actions;
export default twoColumnChartSlice.reducer;
